export default {
  "MatchIcon": "_MatchIcon_s4ndi_1"
};import "ni:sha-256;VbPPnjsPFJBB5xsyRkT-i99flSso0GyxC5uVoY7Og6A";